export default "__VITE_ASSET__B$7zXGP8__"